<template>
	<div class="accessControlEquipmentManagementList">
		<el-form :model="diaForm" :rules="rules" ref="diaForm" :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
				<el-form-item :label="$t('lang.diaFormhouse')" style="color: indianred" >
					<el-select v-model="diaForm.house" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')" class="select"
						@change="getUnit">
						<el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormhouse')" :value='zero'></el-option>
						<el-option v-for="item in houseDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('lang.diaFormunit')">
					<el-select v-model="diaForm.unit" :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormunit')" class="select" @change="changeUnit">
						<el-option key :label="$t('lang.lab_please_Select')+$t('lang.diaFormunit')" :value='zero'></el-option>
						<el-option v-for="item in unitDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="searchDoorDevice()">查询可授权梯控列表</el-button>
					<el-tooltip class="item" effect="light" placement="top">
						<div slot="content">
						<span
							style="font-size:14px">选择所属楼号，单元号，点击“查询可授权梯控列表”按钮，即可对此楼号、单元号下业主进行梯控批量授权。梯控列表会根据点击时所选的楼号单元号动态加载！</span>
						</div>
						<i class="el-icon-warning xjbzTips"></i>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="梯控有效期" prop="doorEndDate">
					<el-date-picker 
					class="authority" 
					v-model="diaForm.doorEndDate" 
					type="date"
					value-format='timestamp'
					:placeholder="$t('lang.lab_selectDeadlineTime')" >
					</el-date-picker>
				</el-form-item>
				<el-form-item label="梯控权限" prop="doorDeviceId">
					<el-select 
					class="multiple-select"
					id='doorDeviceId'
					v-model="diaForm.doorDeviceId" 
					:placeholder="$t('lang.lab_please_Select') + $t('lang.lab_elevatorPermissions')"
					multiple
					filterable
					clearable
					>
					<el-option v-for="item in doorDialist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 电梯地下权限 -->
          <el-form-item :label="$t('lang.lab_elevatorAccess')">
            <el-checkbox-group v-model="diaForm.basementFloor">
              <el-checkbox label="-1"></el-checkbox>
              <el-checkbox label="-2"></el-checkbox>
              <el-checkbox label="-3"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
				<el-button type="primary" @click="save('diaForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
			</div>		
	</div>
</template>

<script>
	/**
	 *@ClassName:accessControlEquipmentManagementList
	 *@Description:门禁设备管理
	 *@author:刘彦辰
	 *@Copyright:格众科技
	 *@date:2020-03-30
	 */
	import { mapGetters } from 'vuex'
	export default {
		name: '/manage/main.doorDeviceList',
		data() {			
			var doorDate = (rule, value, callback) => {
				if (value === undefined || value === null || value === '') {
					callback(new Error(this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_accessControlPeriod')))
				} else {
					callback()
				}
			}
			return {
				zero: 0, // 值为0的变量
				multipleSelection: [], // 多选框
				pageCount: 0, // 总页数
				title: '', // 弹框显示的标题
				pageNo: 1, // 第几页
				pageSize: 10, // 每页显示数
				types: [], // 小区下拉
				houseId: 0, // 楼号ID
				unitId: 0, // 单元号ID
				houseList: [], // 楼号列表
				unitList: [], // 单元号列表
				tableData: [], // 列表数组
				searchMacName: '', // 搜索的关键字
				disabled: true,
				editId: '', // 编辑按钮保存的id
				isPopupPage: false, // 弹框的显示控制
				gardenDialist: [], // 弹框的小区列表
				houseDialist: [], // 弹框的楼号列表
				unitDialist: [], // 弹框的单元列表
				doorDialist: [],
				eqType: this.$i18n.t('lang.accessControlEquipmentManagementList.TYPE'), // 下拉列表
				diaForm: {
					garden: '',
					house: 0,
					unit: 0,
					doorName: '',
					doorMacName: '',
					type: 1,
					doorDeviceId: '',
					doorEndDate: '', // 门禁有效期
					basementFloor: [], // 电梯地下权限
				},
				rules: {
					doorName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_EquipmentName'),
						trigger: 'blur'
					}],
					doorMacName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_inputMacEquipment'),
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_EquipmentType'),
						trigger: 'blur'
					}],					
					doorEndDate: [{ required: true, validator: doorDate, trigger: 'blur' }],
					doorDeviceId: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_staffDoorAuthority'),
						trigger: 'blur'
					}],
				},
				postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
				isDisabled: true, // 保存的可点击
				
			}
		},
		computed: {
			...mapGetters(['gardenId'])
		},
		created() {			
			this.getTablelist()
			this.getHouse()
			// this.getDoorDevice()
		},
		watch: {
			diaForm: {
				handler(newVal, oldVal) {
					// form数据变化时 会调用此方法
					let tempRule = JSON.stringify(newVal)
					if (tempRule == this.saveData) {
						// 没变
						this.isDisabled = true
					} else {
						// 变了
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			searchDoorDevice() {
				this.getDoorDevice()
			},
			// 弹框点击取消按钮
			clear(diaForm) {
				this.$refs[diaForm].resetFields()
				this.diaForm.garden = ''
				this.diaForm.house = 0
				this.diaForm.unit = 0
				this.diaForm.doorName = ''
				this.diaForm.doorMacName = ''
				this.diaForm.basementFloor = []
				this.houseDialist = []
				this.unitDialist = []
				this.diaForm.type = 1
				setTimeout(() => {
					this.$refs[diaForm].clearValidate()
				}, 0)
			},
			// 所属楼号下拉列表获取
			getHouse() {
				this.diaForm.house = 0
				this.houseDialist = []
				this.diaForm.unit = 0
				this.unitDialist = []
				this.type = 1
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.gardenId}&pageNo=1&pageSize=999`).then(res => {
						if (res && res.errCode === 0) {
							this.houseDialist = res.list							
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			changeUnit() {
				this.diaForm.doorDeviceId = ''
				this.diaForm.doorEndDate = ''
				this.doorDialist = []
			},
			// 所属单元下拉列表获取
			getUnit() {
				this.diaForm.doorDeviceId = ''
				this.diaForm.doorEndDate = ''
				this.doorDialist = []
				this.diaForm.unit = 0
				this.unitDialist = []
				this.type = 2
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.diaForm.house}&pageNo=1&pageSize=999`).then(res => {
						if (res && res.errCode === 0) {
							this.unitDialist = res.list
							if (this.diaForm.house === 0) {
								this.diaForm.unit = 0
								this.unitDialist = []
							}
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			getDoorDevice() {
				this.diaForm.doorDeviceId = ''
				this.diaForm.doorEndDate = ''
				this.doorDialist = []
				if (this.diaForm.house === 0 || this.diaForm.house === '') {
					this.$message.error('请选择楼号')
					return
				}
				if (this.diaForm.unit === 0 || this.diaForm.unit === '') {
					this.$message.error('请选择单元号')
					return
				}
				this.$get(`/lift?garden=${this.gardenId}&house=${this.diaForm.house}&unit=${this.diaForm.unit}&pageNo=1&pageSize=999`).then(res => {
						if (res && res.errCode === 0) {
							this.doorDialist = res.list							
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			// 所属小区下拉列表获取
			getGarden() {
				this.$get(`/gardens`).then(res => {
						if (res && res.errCode === 0) {
							this.types = res.list
							this.gardenDialist = res.list
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			// 添加门禁设备
			add() {
				this.diaForm.garden = ''
				this.diaForm.house = 0
				this.diaForm.unit = 0
				this.houseDialist = []
				this.unitDialist = []
				this.editId = ''
				this.diaForm.doorName = ''
				this.diaForm.doorMacName = ''
				this.diaForm.type = 1
				this.title = this.$i18n.t('lang.lab_addEquipment')
				this.isDisabled = false
				this.isPopupPage = true
				this.$refs.diaForm.clearValidate()
			},
			// 跳转子门禁
			doorDeviceSonList(id) {
				this.$router.push({
					path: '/manage/doorDeviceSon',
					query: {
						id: id
					}
				})
			},
			// 跳转星朗设备
			xlDeviceList(id) {
				this.$router.push({
					path: '/manage/xlDevice',
					query: {
						id: id
					}
				})
			},
			// 编辑门禁设备
			edit(row) {
				this.title = this.$i18n.t('lang.lab_editEquipment')
				this.editId = row.id
				this.diaForm.type = row.type
				this.diaForm.garden = row.gardenId
				// this.diaForm.type = 1
				this.$get(`/gardenGrids?type=${this.diaForm.type}&parentId=${this.diaForm.garden}&pageNo=1&pageSize=999`).then(res => {
						if (res && res.errCode === 0) {
							this.houseDialist = res.list
						}
					},
					error => {
						this.$message.error(error)
					})
				this.diaForm.house = row.house
				if (this.diaForm.house != null && this.diaForm.house != 0) {
					// this.diaForm.type = 2
					this.$get(`/gardenGrids?type=${this.diaForm.type}&parentId=${this.diaForm.house}&pageNo=1&pageSize=999`).then(res => {
							if (res && res.errCode === 0) {
								this.unitDialist = res.list
								}
							},
							error => {
								this.$message.error(error)
							})
					} else {
					this.diaForm.house = 0
					this.diaForm.unit = 0
					this.unitDialist = []
				}
				if (row.unit === null) {
					this.diaForm.unit = 0
				} else {
					this.diaForm.unit = row.unit
				}
				this.diaForm.doorMacName = row.doorMacName
				this.diaForm.doorName = row.doorName
				this.saveData = JSON.stringify(this.diaForm)
				this.isPopupPage = true
			},
			// 添加/保存按下确定
			save(diaForm) {
				this.$refs[diaForm].validate((valid) => {
						if (valid) {
							let params = {
								gardenId: this.gardenId,
								houseId: this.diaForm.house,
								unitId: this.diaForm.unit,
								liftEndDate: this.diaForm.doorEndDate,
								liftDeviceId: this.diaForm.doorDeviceId.toString(),
								basementFloor: this.diaForm.basementFloor.toString()
							}
							let loading = this.$loading()
							this.$post(`/users/liftRightBatch`, params).then(
								res => {
									loading.close()
									// if (res && res.errCode === 0) {
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									this.clear('diaForm')
									this.getHouse()
									// }
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
			},
			// 翻页
			handleCurrentChange(val) {
				this.pageNo = val
				this.getTablelist()
			},
			// 切换每页显示多少数据
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.getTablelist()
			},
			// 监听关闭dialog
			handleDialogClosed() {
				this.$refs.diaForm.resetFields()
				this.diaForm.unit = 0
				this.diaForm.house = 0
				this.diaForm.garden = ''
				this.diaForm.type = 1
				this.diaForm.name = ''
				this.diaForm.macName = ''
			},
			// 列表隔行变色
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			// ID序号功能
			indexMethod(index) {
				return (this.pageNo - 1) * this.pageSize + index + 1
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			// 门禁设备管理
			getTablelist() {
				let loading = this.$loading()
				this.$get(
					`/doorDevice/?garden=${this.gardenId}&house=${this.houseId}&unit=${this.unitId}&doorName=${this.searchMacName}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
				).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.tableData = res.list
							this.pageCount = res.pageCount
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			commit() {
				this.pageNo = 1
				this.getTablelist()
			},
			// 获取小区下的楼号
			getListHouse() {
				this.houseId = 0
				this.houseList = []
				this.unitId = 0
				this.unitList = []
				this.type = 1
				let loading = this.$loading()
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.gardenId}&pageNo=1&pageSize=999`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.houseList = res.list
							if (this.gardenId === 0) {
								this.houseId = 0
								this.houseList = []
								this.unitId = 0
								this.unitList = []
							}
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			// 获取楼号下的单元号
			getListUnit() {
				this.unitId = 0
				this.unitList = []
				this.type = 2
				let loading = this.$loading()
				this.$get(`/gardenGrids?type=${this.type}&parentId=${this.houseId}&pageNo=1&pageSize=999`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.unitList = res.list
							if (this.houseId === 0) {
								this.unitId = 0
								this.unitList = []
							}
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			deletetable(id) {
				let loading = this.$loading()
				this.$confirm(
						this.$i18n.t('lang.lab_isdelete'),
						this.$i18n.t('lang.lab_prompt'), {
							confirmButtonText: this.$i18n.t('lang.btn_confirm'),
							cancelButtonText: this.$i18n.t('lang.btn_cancel'),
							type: 'warning'
						}
					).then(() => {
						// 添加del的url
						this.$delete(`/doorDevice/` + id).then(res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.commit()
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							})
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
			}
		}
	}
</script>

<style lang="scss">

</style>
